import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SortButtonComponent } from '@sortaify/components';

export interface NavigationConfirmationData {
  question: string;
}

@Component({
  selector: 'app-navigation-confirmation-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatIconModule, SortButtonComponent],
  template: `
    <div class="p-6 flex flex-col gap-4">
      <div class="flex items-start gap-4">
        <div class="w-12 h-12 rounded-xl bg-amber-500/10 flex flex-col items-center justify-center flex-shrink-0">
          <mat-icon class="text-amber-400 text-2xl leading-6">warning</mat-icon>
        </div>
        <div class="flex flex-col gap-1 pt-1">
          <h2 class="text-base font-bold text-white m-0">Unsaved Changes</h2>
          <p class="text-sm text-white/60 m-0">{{ data.question }}</p>
        </div>
      </div>

      <div class="flex justify-end gap-3 pt-2">
        <sortaify-button variant="secondary" (buttonClick)="onStay()">
          Stay
        </sortaify-button>
        <sortaify-button variant="secondary" (buttonClick)="onLeave()">
          Leave
        </sortaify-button>
      </div>
    </div>
  `,
})
export class NavigationConfirmationDialogComponent {
  private dialogRef = inject(MatDialogRef<NavigationConfirmationDialogComponent>);
  data = inject<NavigationConfirmationData>(MAT_DIALOG_DATA);

  onStay(): void {
    this.dialogRef.close(false);
  }

  onLeave(): void {
    this.dialogRef.close(true);
  }
}

import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({ providedIn: 'root' })
export class NavigationConfirmationService {
  private dialog = inject(MatDialog);

  async askBeforeNavigation(question: string): Promise<boolean> {
    const dialogRef = this.dialog.open(NavigationConfirmationDialogComponent, {
      data: { question },
      disableClose: true,
    });

    return dialogRef.afterClosed().toPromise() ?? false;
  }
}
